import { render } from "./BattlesOverview.vue?vue&type=template&id=28b8c80b&scoped=true"
import script from "./BattlesOverview.vue?vue&type=script&lang=js"
export * from "./BattlesOverview.vue?vue&type=script&lang=js"

import "./BattlesOverview.vue?vue&type=style&index=0&id=28b8c80b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b8c80b"]])

export default __exports__